const AddItem = item => ({
  type: "ADD_ITEM",
  item
});

export default AddItem;
